import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../core/interceptor/http-interceptor-config";
import Api from "../core/api/api";

export const getEmployeeList = createAsyncThunk(
  "template/getEmployeeList",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.employee_list}${data}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getDeactivateUser = createAsyncThunk(
  "template/getDeactivateUser",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.patch(`${Api.deactivate_user}${data}`);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getLocationList = createAsyncThunk(
  "template/getLocationList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `${Api.location_list}?limit=250`
      );
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const companyGroupList = createAsyncThunk(
  "template/companyGroupList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.company_group_list}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const companyPayGroupList = createAsyncThunk(
  "template/companyPayGroupList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.company_pay_group_list}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const jobCodeList = createAsyncThunk(
  "template/jobCodeList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.job_code_list}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getCampaignsList = createAsyncThunk(
  "template/getCampaignsList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.campaigns}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getServicesList = createAsyncThunk(
  "template/getServicesList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.services}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);


export const getEntityList = createAsyncThunk(
  "template/getEntityList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.entity_list}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getReportingPersonList = createAsyncThunk(
  "template/getReportingPersonList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.qa_supervisor}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getDepartmentList = createAsyncThunk(
  "template/getDepartmentList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.department_list}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getRoleList = createAsyncThunk(
  "template/getRoleList",
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.role_list}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getUserById = createAsyncThunk(
  "template/getUserById",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.user_by_id}${data}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getExportUserList = createAsyncThunk(
  "template/getExportUserList",
  async (data:any, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`${Api.export_user_list}${data}`);
      return response?.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
})

export const getUploadList = createAsyncThunk(
  "template/getUploadList",
  async (data:any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(`${Api.user_upload}`, data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message);
    }
})

export const putEditUserList = createAsyncThunk(
  "template/putEditUserList",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(`${Api.edit_user}`, data);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.error?.data);
    }
})
    
export const getCreateUser = createAsyncThunk(
  "template/getCreateUser",
  async (formData: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(Api.create_user, formData);
      return response;
    }  catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message?.non_field_errors || "Failed to Create user");
    }
  }
);
